'use client';

import { Database } from 'lucide-react';
import { EntitlementAccessDialog } from '@/components/entitlement-access-dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogMedia,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useAuth } from '@/contexts/auth-context';
import { useLanguage } from '@/contexts/language-context';
import type { FeatureRestriction } from '@/lib/feature-permissions';

type Feature = 'chat-usage' | 'deep-data' | 'kline-chart' | 'recommendation' | 'trading-profile';

interface FeatureAccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  restriction: FeatureRestriction;
  feature?: Feature;
}

export function FeatureAccessDialog({ open, onOpenChange, restriction }: FeatureAccessDialogProps) {
  const { t } = useLanguage();
  const { user } = useAuth();

  if (restriction !== 'daily-limit') {
    return (
      <EntitlementAccessDialog
        open={open}
        onOpenChange={onOpenChange}
        level={restriction === 'login' ? 'L0' : user?.level}
      />
    );
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent size="default" className="border border-white/[0.08] bg-[#231f20]">
        <AlertDialogHeader>
          <AlertDialogMedia className="rounded-full border border-white/10 bg-white/[0.06] text-[#F98715]">
            <Database className="h-7 w-7" />
          </AlertDialogMedia>
          <AlertDialogTitle className="text-white">{t('featureAccess.dailyLimitTitle')}</AlertDialogTitle>
          <AlertDialogDescription className="text-white/60">
            {t('featureAccess.dailyLimitDescription')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            variant="ghost"
            className="text-white hover:text-white"
            style={{ backgroundColor: '#F98715' }}>
            {t('featureAccess.gotIt')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
